import React from "react";
import { Link } from "react-router-dom";
import audioFilesImage from "../../assets/images/Audio files.svg";
import { cn } from "../../lib/cn";

export interface AppLogoProps {
  className?: string;
}

const AppLogo = ({ className }: AppLogoProps) => {
  return (
    <Link to="/home" className={cn("flex items-center gap-2 rounded-full px-2 py-1.5", className)}>
      <img src={audioFilesImage} alt="Voice App Logo" className="h-8 w-8" />
      <span className="text-lg font-semibold text-gray-600 dark:text-orange-200">VOC</span>
    </Link>
  );
};

export default AppLogo;
